import { User as FirebaseAuthUser } from 'firebase/auth';
import { EmailUser } from 'hydra-data-types';
import { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REFERRAL_URL_TYPE } from '../constants';
import { ActionType, ConnectInitializeUser } from './StoreTypes';

// Valid during Auth, user may or may not have been set
export type AuthStoreState = {
  user?: ConnectInitializeUser | EmailUser;
  firebaseUser?: FirebaseAuthUser;
  userStatus: { firstTimeVisit: boolean };
  authenticatingExistingMindsetId: boolean;
  hcpReferralHash: string | undefined;
  referralUrlType: REFERRAL_URL_TYPE;
};

export type AuthStoreAction =
  | {
      type: ActionType.SET_USER;
      user: ConnectInitializeUser | EmailUser | undefined;
    }
  | {
      type: ActionType.SET_FIREBASE_USER;
      firebaseUser: FirebaseAuthUser | undefined;
    }
  | {
      type: ActionType.CLEAR_USER;
    }
  | {
      type: ActionType.SET_USER_STATUS;
      userStatus: { firstTimeVisit: boolean };
    }
  | {
      type: ActionType.SET_AUTHENTICATING_EXISTING_MINDSET_ID;
      authenticatingExistingMindsetId: boolean;
    }
  | {
      type: ActionType.SET_HCP_PATIENT_LINK_ID;
      hcpReferralHash: string | undefined;
    }
  | {
      type: ActionType.SET_REFERRAL_URL_TYPE;
      referralUrlType: REFERRAL_URL_TYPE;
    };

/**
 * React hook for FunctionComponents to retrieve state from store. Stronger typing than useSelector.
 * This hook is valid to use within the Auth Stack.
 */
export function useAuthStore<Selected>(
  selector: (state: AuthStoreState) => Selected,
  equalityFn?: (left: Selected, right: Selected) => boolean
) {
  return useSelector<AuthStoreState, Selected>(selector, equalityFn);
}

/**
 * React hook for FunctionComponents to dispatch actions to the store. Stronger typing than useDispatch.
 * This hook is valid to use within the Auth Stack.
 */
export function useAuthDispatch(): Dispatch<AuthStoreAction> {
  return useDispatch<Dispatch<AuthStoreAction>>();
}
